import React from 'react';
import lock from '../assets/lock.svg'
import { useFormik } from 'formik';
import PassShowHide from '../components/passShowHide'

const validate = values => {
    const errors = {};
    if (!values.name) {
      errors.name = 'Campo obrigatório';
    } else if (values.name.length > 15) {
      errors.name = 'Precisa ter 15 caracteres ou menos';
    }
  
    if (!values.email) {
      errors.email = 'Campo obrigatório';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = 'Digite um email válido';
    }

    if (!values.password) {
        errors.password = 'Campo obrigatório';
      } else if (values.password.length <= 6) {
        errors.password = 'Precisa ter 6 caracteres ou mais';
      }
    
      if (!values.confirmPassword) {
        errors.confirmPassword = 'Campo obrigatório';
      } else if (values.confirmPassword <= 6) {
        errors.confirmPassword = 'Must be 6 characters or more';
      } else if (values.confirmPassword !== values.password) {
        errors.confirmPassword = 'As senhas não conferem';
      }
  
    return errors;
  };

export default function ChangePass({history}) {
  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword:'',
    },
    validate,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: values => {
      console.log(values);
    },
  });
    
  return (
    <>
      <div className='container login d-flex flex-column align-items-center bg-light'>
        <h4 className='mb-4'>Alteração de Senha</h4>
        <form className='form' onSubmit={formik.handleSubmit}>

        <div className="input-group input-group mb-4 mr-sm-2">
                        <div className="input-group-prepend">
                            <div className= {formik.errors.password ? "input-group-text borderRed" : "input-group-text"}>
                                <img className="" src={lock} alt="logo" width="18" height="18" />
                            </div>
                        </div>
                        <PassShowHide 
                            className= {formik.errors.password ? "form-control borderRed" : "form-control"} 
                            id="password" 
                            name="password"
                            placeholder='Nova senha'
                            onChange={formik.handleChange}
                            value={formik.values.password}/>
                        {formik.errors.password ? <div className='invalid'>{formik.errors.password}</div> : null}
                    </div>

                    <div className="input-group input-group mb-4 mr-sm-2">
                        <div className="input-group-prepend">
                            <div className={formik.errors.confirmPassword ? "input-group-text borderRed" : "input-group-text"}>
                                <img className="" src={lock} alt="logo" width="18" height="18" />
                            </div>
                        </div>
                        <PassShowHide 
                            className= {formik.errors.confirmPassword ? "form-control borderRed" : "form-control"}  
                            id="confirmPassword" 
                            name='confirmPassword'
                            placeholder='Confirme a nova senha'
                            onChange={formik.handleChange}
                            value={formik.values.confirmPassword}/>
                        {formik.errors.confirmPassword ? <div className='invalid'>{formik.errors.confirmPassword}</div> : null}
                    </div>

          <button className="btn btn-outline-dark btn-block w-100 mb-2" type="submit">Alterar</button>

        </form>
      </div>
    </>
  );
}
//<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>